import { ApolloClient, InMemoryCache, HttpLink, ApolloLink, from } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { STRAPI_USER_STORAGE_KEY } from './constants/index'
import { fetchJwt } from './utils'

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_API_HOST + '/graphql'
})

const authLink = new ApolloLink((operation, forward) => {
  const token = fetchJwt()
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : ''
    }
  })
  return forward(operation)
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors?.[0]?.message === 'Invalid token.') {
    globalThis.localStorage.removeItem(STRAPI_USER_STORAGE_KEY)
    globalThis.sessionStorage.removeItem(STRAPI_USER_STORAGE_KEY)
    globalThis.location.replace(process.env.REACT_APP_CLIENT_HOST || '')
  }
})

const client = new ApolloClient({
  link: from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache({ addTypename: false })
})

export default client
